export default "__VITE_ASSET__CH94Db2Z__"